import messageSent from "../../../assets/general/message-sent.svg";

type SubmitStatus = "success" | "error";

interface ContactStatusProps {
  status: SubmitStatus;
  errorMessage?: string;
}

export function ContactStatus({ status, errorMessage }: ContactStatusProps) {
  if (status === "success") {
    return (
      <div className="form-message message-success">
        <img className="message-image" src={messageSent} alt="message sent" />
        <label className="message-text">Message Sent!</label>
      </div>
    );
  }

  return (
    <div className="form-message message-error">
      <label className="message-text">{errorMessage ?? "Something went wrong. Please try again."}</label>
    </div>
  );
}
